(ns frontend.view.nev.oppo.sub
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::id->entity
 (fn [db]
   (::id->entity db)))

(rf/reg-sub
  ::initial-data-loaded?
  (fn [db]
    (::initial-data-loaded? db)))
